import { isEmail, isPhone } from "services/utils/regexForValidations"

export const INITIAL_VALUES_ANALYST = {
  typeOfAttendance: "",
  customerFullName: "",
  customerEmail: "",
  customerDocument: "",
  customerPhone: "",
  state: "",
  city: "",
  locality: "",
  file: null,
  reason: ""
}

export const OPTIONS_ATTENDANCE = [
  "Ativação com portabilidade",
  "Ativação sem Portabilidade",
  "Reagendamento Portabilidade",
  "Suspensão Portabilidade",
  "Cancelamento pedido portabilidade"
]

export const NEW_NUMBER = {
  typeOfAttendance: {
    name: "typeOfAttendance",
    placeholder: "Tipo de atendimento"
  },
  customerFullName: {
    name: "customerFullName",
    placeholder: "Nome completo*"
  },
  customerEmail: {
    name: "customerEmail",
    placeholder: "E-mail*"
  },
  customerDocument: {
    name: "customerDocument",
    placeholder: "Selecione o CPF ou CNPJ*"
  },
  customerPhone: {
    name: "customerPhone",
    placeholder: "Telefone*"
  },
  state: {
    name: "state",
    placeholder: "Estado*"
  },
  city: {
    name: "city",
    placeholder: "Cidade*"
  },
  locality: {
    name: "locality",
    placeholder: "Localidade*"
  },
  reason: {
    name: "reason",
    placeholder: "Escreva aqui...",
    limit: 500
  }
}

export const validate = (values) => {
  const errors = {}

  if (!values.customerFullName) {
    errors.customerFullName = "*Preencher o nome completo do parceiro."
  } else if (values.customerFullName.trim().length < 3) {
    errors.customerFullName = "*Nome completo precisa de no mínimo 3 caracteres"
  }

  if (!values.customerDocument) {
    errors.customerDocument = "*Selecione o documento CPF ou CNPJ do parceiro."
  }

  if (!values.customerEmail) {
    errors.customerEmail = "*Preencher com o email do parceiro."
  } else if (!isEmail(values.customerEmail)) {
    errors.customerEmail = "*Email do parceiro incorreto."
  }

  if (!values.customerPhone) {
    errors.customerPhone = "*Preencher com o phone do parceiro."
  } else if (!isPhone(values.customerPhone)) {
    errors.customerPhone = "*Telefone de contato incorreto."
  }

  if (!values.state) {
    errors.state = "*Selecione o estado."
  }

  if (!values.city) {
    errors.city = "*Selecione a cidade."
  }

  if (!values.locality) {
    errors.locality = "*Selecione a localidade."
  }

  if (!values.reason) {
    errors.reason = "*Preencher o motivo da solicitação."
  } else if (values.reason.length < 20) {
    errors.reason = "*Escrever o motivo com pelo menos 20 caracteres."
  }

  if (!values.file) {
    errors.file = "*Por Gentileza, anexar uma planilha de xlsx."
  }

  return errors
}

const SALES_PORT =
  "https://tic-ecommerce-hml.s3.amazonaws.com/PLANILHA+NUMEROS+NOVOS+1+(1)+(1).xlsx"
const RESCHEDULE =
  "https://tic-ecommerce-hml.s3.amazonaws.com/Planilha+Portal+-+Reagendamento+(1).xlsx"
const SUSPENSION_CANCEL =
  "https://tic-ecommerce-hml.s3.amazonaws.com/Planilha+Portal+-+Suspens%C3%A3o+ou+Cancelamento+(1).xlsx"

export const CATEGORIES = [
  {
    name: "ATIVACAO_COM_PORTABILIDADE",
    desc: "Ativação com portabilidade",
    file: SALES_PORT
  },
  {
    name: "ATIVACAO_SEM_PORTABILIDADE",
    desc: "Ativação sem Portabilidade",
    file: SALES_PORT
  },
  {
    name: "REAGENDAMENTO",
    desc: "Reagendamento Portabilidade",
    file: RESCHEDULE
  },
  {
    name: "SUSPENSAO",
    desc: "Suspensão Portabilidade",
    file: SUSPENSION_CANCEL
  },
  {
    name: "CANCELAMENTO",
    desc: "Cancelamento pedido portabilidade",
    file: SUSPENSION_CANCEL
  }
]

export const DEFAULT_MESSAGE = {
  SPECIALIST_INFO:
    " Evite enviar várias solicitações para a análise de especialista, use\n" +
    "        este recurso somente quando necessário para assim conseguirmos te\n" +
    "        atender de forma mais rápida."
}



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/ExpertAnalysis/constants.js